import { LoadingButton, Props as LoadingButtonProps } from '../LoadingButton';
import { FC } from 'react';
import styled from '@emotion/styled';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

export type Props = LoadingButtonProps;

export const NormalButton: FC<Props> = (props) => {
  return <StyledLoadingButton {...props} />;
};

const StyledLoadingButton = styled(LoadingButton)((props) => {
  return {
    height: '32px',
    fontSize: '14px',
    fontWeight: 'bold',
    borderRadius: '4px',
    ...(props.variant === 'outlined' && {
      color: COLOR_TEXT_MAIN,
      background: '#FFFFFF',
      border: '1.5px solid #E6E7E8',
      marginRight: '16px',
      ':hover': {
        background: '#FFFFFF',
      },
    }),
    ...(props.variant === 'contained' && {
      color: '#FFFFFF',
      background: COLOR_TEXT_MAIN,
      borderColor: COLOR_TEXT_MAIN,
      ':hover': {
        background: '#707889',
        borderColor: '#707889',
      },
      ':disabled': {
        background: '#E6E7E8',
        color: 'rgba(75, 85, 106, 0.24)',
        border: 'rgba(75, 85, 106, 0.24)',
      },
    }),
  };
});
